<div class="container-fluid administration-page">

    <!-- ====================================================== -->
    <!-- CONTENEDOR PRINCIPAL -->
    <!-- ====================================================== -->

    <div class="administration-card">

        <!-- ================================================== -->
        <!-- HEADER -->
        <!-- ================================================== -->

        <div class="administration-header">

            <div class="header-content">

                <div class="header-info">

                    <h1 class="page-title">
                        Administración de Sobres
                    </h1>

                    <p class="page-description">
                        Gestiona, consulta y crea sobres de documentos.
                    </p>

                </div>


                <!-- ========================================== -->
                <!-- ACCIONES -->
                <!-- ========================================== -->

                <div class="header-actions">

                    <button
                        type="button"
                        class="btn-action btn-action-primary"
                        (click)="CreaLote()">

                        <i class="fa-solid fa-plus"></i>

                        <span>
                            Crear sobre
                        </span>

                    </button>


                    <button
                        type="button"
                        class="btn-action btn-action-secondary"
                        (click)="CreaLoteExterno()">

                        <i class="fa-solid fa-arrow-up-right-from-square"></i>

                        <span>
                            Crear sobre externo
                        </span>

                    </button>

                </div>

            </div>

        </div>


        <!-- ================================================== -->
        <!-- BODY -->
        <!-- ================================================== -->

        <div class="administration-body">


            <!-- ================================================= -->
            <!-- TOOLBAR -->
            <!-- ================================================= -->

            <div class="content-toolbar">


                <!-- ============================================= -->
                <!-- BUSCADOR -->
                <!-- ============================================= -->

                <div class="search-container">

                    <form
                        [formGroup]="searchForm"
                        class="search-form">

                        <div class="search-box">

                            <div class="search-icon">

                                <i class="fa-solid fa-magnifying-glass"></i>

                            </div>


                            <input
                                type="text"
                                class="search-input"
                                placeholder="Buscar sobre..."
                                formControlName="search"
                                (keyup.enter)="buscarLote()">


                            <button
                                class="search-button"
                                type="button"
                                (click)="buscarLote()">

                                Buscar

                            </button>

                        </div>

                    </form>

                </div>


                <!-- ============================================= -->
                <!-- TABS -->
                <!-- ============================================= -->

                <div class="tab-switcher">

                    <button
                        type="button"
                        class="tab-btn"
                        [class.active]="!loteCompartido"
                        (click)="cambiarTab(false)">

                        <i class="fa-solid fa-user"></i>

                        <span>
                            Mis sobres
                        </span>

                    </button>


                    <button
                        type="button"
                        class="tab-btn"
                        [class.active]="loteCompartido"
                        (click)="cambiarTab(true)">

                        <i class="fa-solid fa-share-nodes"></i>

                        <span>
                            Compartidos conmigo
                        </span>

                    </button>

                </div>

            </div>


            <!-- ================================================= -->
            <!-- TABLA -->
            <!-- ================================================= -->

            <div class="table-section">

                <app-paginacion
                    [currentPage]="currentPage"
                    [totalItems]="totalItems"
                    [selectedPageSize]="pageSize"
                    [paginatedData]="currentItems"
                    [headers]="tableHeaders"
                    [actions]="customActions"
                    [loading]="spinner"
                    (pageChange)="onPageChange($event)"
                    (pageSizeChange)="onPageSizeChange($event)">
                </app-paginacion>

            </div>

        </div>

    </div>

</div>


<!-- ======================================================== -->
<!-- MODAL CERTIFICADOS -->
<!-- ======================================================== -->

<ng-template #participantesContent let-modal>

    <div class="certificates-modal">


        <!-- ================================================== -->
        <!-- HEADER -->
        <!-- ================================================== -->

        <div class="modal-header-custom">

            <div class="modal-heading">

                <div class="modal-icon">

                    <i class="fa-solid fa-users-gear"></i>

                </div>


                <div>

                    <h4
                        class="modal-title-custom"
                        id="modal-basic-title">

                        Certificados

                    </h4>

                    <p class="modal-description">
                        Certificados asociados al sobre.
                    </p>

                </div>

            </div>


            <button
                type="button"
                class="modal-close"
                aria-label="Close"
                (click)="modal.dismiss('Cross click')">

                <i class="fa-solid fa-xmark"></i>

            </button>

        </div>


        <!-- ================================================== -->
        <!-- BODY -->
        <!-- ================================================== -->

        <div class="modal-body-custom">

            <div class="modal-table-container">

                <div class="table-responsive">

                    <table class="table certificates-table">

                        <caption class="visually-hidden">
                            Participantes
                        </caption>


                        <thead>

                            <tr>

                                <th scope="col">
                                    Usuario
                                </th>

                                <th scope="col">
                                    Certificado
                                </th>

                                <th scope="col">
                                    Scratchcard
                                </th>

                                <th scope="col">
                                    Estado
                                </th>

                            </tr>

                        </thead>


                        <tbody>


                            <!-- ================================= -->
                            <!-- REGISTROS -->
                            <!-- ================================= -->

                            <tr *ngFor="let item of loteCertificado">

                                <td>
                                    {{ item.nombre }}
                                </td>

                                <td>
                                    {{ item.tipoCertificado.nombre }}
                                </td>

                                <td>

                                    <span class="scratchcard-value">
                                        {{ item.scratchcard }}
                                    </span>

                                </td>

                                <td>

                                    <span
                                        class="status-badge"
                                        [ngClass]="item.estado.clase">

                                        {{ item.estado.nombre }}

                                    </span>

                                </td>

                            </tr>


                            <!-- ================================= -->
                            <!-- SIN RESULTADOS -->
                            <!-- ================================= -->

                            <tr *ngIf="!loteCertificado.length">

                                <td
                                    colspan="4"
                                    class="modal-empty-cell">

                                    <div class="modal-empty-state">

                                        <div class="modal-empty-icon">

                                            <i class="fa-solid fa-certificate"></i>

                                        </div>

                                        <span class="modal-empty-title">
                                            No hay certificados
                                        </span>

                                        <span class="modal-empty-description">
                                            No se encontraron resultados para esa búsqueda.
                                        </span>

                                    </div>

                                </td>

                            </tr>

                        </tbody>

                    </table>

                </div>

            </div>

        </div>


        <!-- ================================================== -->
        <!-- FOOTER -->
        <!-- ================================================== -->

        <div class="modal-footer-custom">

            <button
                type="button"
                class="btn-modal-close"
                (click)="modal.close('Cerrar click')">

                Cerrar

            </button>

        </div>

    </div>

</ng-template>